





import { BvModal } from "bootstrap-vue";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class ConfirmDialog extends Vue {
  @Prop({ default: "", type: String }) title!: string;
  @Prop({ default: "Are you sure?", type: String }) message!: string;
  @Prop({ default: "Yes", type: String }) okButton!: string;
  @Prop({ default: "No", type: String }) cancelButton!: string;

  @Emit()
  show(ok?: Function, cancel?: Function) {
    const modal = this.$bvModal as BvModal;
    modal
      .msgBoxConfirm(this.message, {
        title: this.title,
        okTitle: this.okButton,
        cancelTitle: this.cancelButton,
        centered: true,
      })
      .then((value: boolean) => {
        if (value && ok) {
          ok();
        } else if (!value && cancel) {
          cancel();
        }
      });
  }
}
